import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const Editor = forwardRef(
  ({ value, onChange, placeholder = "Escribe algo...", readOnly = false }, ref) => {
    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const isSettingContent = useRef(false);

    useEffect(() => {
      if (editorRef.current) {
        quillRef.current = new Quill(editorRef.current, {
          theme: "snow",
          placeholder,
          readOnly,
          modules: {
            toolbar: [
              [{ 'font': [] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['image'],
              ["clean"],
            ],
          },
        });

        // Establecer contenido inicial
        quillRef.current.root.innerHTML = value;

        // Escuchar cambios del editor
        quillRef.current.on("text-change", () => {
          if (!isSettingContent.current) {
            const html = quillRef.current.root.innerHTML;
            onChange(html);
          }
        });
      }

      return () => {
        quillRef.current = null;
      };
    }, []);

    // Actualizar contenido si cambia desde fuera
    useEffect(() => {
      if (quillRef.current) {
        const current = quillRef.current.root.innerHTML;
        if (value !== current) {
          isSettingContent.current = true;
          quillRef.current.root.innerHTML = value;
          isSettingContent.current = false;
        }
      }
    }, [value]);

    // 👇 Expone funciones al padre
    useImperativeHandle(ref, () => ({
      insertText(text, formats = {}) {
        if (!quillRef.current) return;

        const quill = quillRef.current;
        const range = quill.getSelection(true);
        if (range) {
          quill.insertText(range.index, text, formats);
          quill.setSelection(range.index + text.length);
        }
      },
    }));

    return <div ref={editorRef} style={{ height: "256px" }} />;
  }
);

export default Editor;
